import { Input, Spinner } from '@platform/components';

type UnresponsiveContentProps = {
  additionalDetails: string;
  setAdditionalDetails: (details: string) => void;
  otherPartyName: string;
  isSaving: boolean;
};

export const UnresponsiveContent = (props: UnresponsiveContentProps) => {
  const { additionalDetails, setAdditionalDetails, otherPartyName, isSaving } = { ...props };

  return (
    <div className='flex flex-col gap-4 md:mt-8 items-center md:w-[500px]'>
      {isSaving ?
        <Spinner />
      : <>
          <div className='text-center text-lg'>
            Sorry to hear {otherPartyName} has been unresponsive. We'll reach out to them to see
            what's going on, and update you with next steps via email.
          </div>
          <div className='text-center text-lg'>
            If you have any additional details to share, you can do so below.
          </div>
          <div className='mt-4 w-full items-stretch'>
            <div className='text-sm'>Additional details (optional)</div>
            <Input
              characterCount={500}
              type='multiline'
              placeholder='Anything else you want to tell us...'
              onChange={(e) => {
                setAdditionalDetails(e.target.value);
              }}
              value={additionalDetails}
            />
          </div>
        </>
      }
    </div>
  );
};
